import React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import api from '../services/api';
import { useDispatch } from 'react-redux';
import { setSnackbar } from '../redux/snackbar';

export default function NewUnity(props) {
  const [name, setName] = React.useState(props.name);
  const [sigla, setSigla] = React.useState('');
  const dispatch = useDispatch();

  async function handleUnity(e) {
    e.preventDefault();
    const data = { name, sigla };
    try {
      await api.post('/unities', data).then((resp) => {
        props.onSave(resp.data);
      });
    } catch (err) {
      dispatch(
        setSnackbar(
          true,
          'error',
          'Erro ao submeter ação! Tente novamente.',
        ),
      );
    }
  }

  function handleClose() {
    props.onClose();
  }

  return (
    <div>
      <Dialog open={props.open} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Preencha as informações da nova unidade de medida</DialogTitle>
        <DialogContent>
          <form onSubmit={handleUnity}>
            <Grid container direction="column" spacing={2}>
              <Grid item xs>
                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  fullWidth
                  label="Nome"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </Grid>
              <Grid item xs>
                <TextField
                  autoFocus
                  margin="dense"
                  id="sigla"
                  fullWidth
                  label="Sigla/Símbolo"
                  type="text"
                  value={sigla}
                  onChange={(e) => setSigla(e.target.value)}
                />
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button className="button" color="primary" onClick={handleUnity}>
            Submeter
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
